import { useTranslation } from 'next-i18next';
import styles from '@components/ProjectFeatures/ProjectFeatures.styles';
import Icon from '@components/icons/Icon';
type PropsType = {
  surface?: string | null | undefined;
  furniture?: string[] | null | undefined;
  doors?: string[] | null | undefined;
  floor?: string[] | null | undefined;
  walls?: string[] | null | undefined;
  rows?: boolean;
  isListing?: boolean;
};
const ProjectFeatures = ({
  surface,
  furniture,
  doors,
  floor,
  walls,
  rows = true,
  isListing = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  return <div sx={styles.features(isListing)} data-testid="ProjectFeatures">
      <div sx={styles.container(rows, isListing)} data-testid="ProjectFeatures-container">
        {furniture && furniture.length > 0 && <div sx={styles.feature(isListing)} data-testid="ProjectFeatures-furniture">
            <Icon icon="Furniture" size={isListing ? '24px' : '40px'} color="darkGrey700" />
            {t('furnitures')}:&nbsp;
            {furniture.map(f => <span key={f} data-testid="ProjectFeatures-furniture-item">
                &nbsp;{f}
              </span>)}
          </div>}
        {walls && walls.length > 0 && <div sx={styles.feature(isListing)} data-testid="ProjectFeatures-walls">
            <Icon icon="Walls" size={isListing ? '24px' : '40px'} color="darkGrey700" />
            {t('wall')}:&nbsp;
            {walls.map(w => <span key={w} data-testid="ProjectFeatures-walls-item">
                {' '}
                {w}
              </span>)}
          </div>}
        {doors && doors.length > 0 && <div sx={styles.feature(isListing)} data-testid="ProjectFeatures-doors">
            <Icon icon="Doors" size={isListing ? '24px' : '40px'} color="darkGrey700" />
            {t('door')}:&nbsp;
            {doors.map(d => <span key={d} data-testid="ProjectFeatures-doors-item">
                &nbsp;{d}
              </span>)}
          </div>}
        {floor && floor.length > 0 && <div sx={styles.feature(isListing)} data-testid="ProjectFeatures-floor">
            <Icon icon="Floor" size={isListing ? '24px' : '40px'} color="darkGrey700" />
            {t('floor')}:&nbsp;
            {floor.map(f => <span key={f} data-testid="ProjectFeatures-floor-item">
                &nbsp;{f}
              </span>)}
          </div>}
      </div>
      <div sx={styles.surface} data-testid="ProjectFeatures-surface">
        {surface && surface.length > 0 && <div sx={styles.feature(isListing)} data-testid="ProjectFeatures-surface-feature">
            <Icon icon="Surface" size={isListing ? '24px' : '40px'} color="darkGrey700" />
            <span data-testid="ProjectFeatures-surface-value">
              {surface} m<sup data-testid="ProjectFeatures-surface-unit">2</sup>
            </span>
          </div>}
      </div>
    </div>;
};
export default ProjectFeatures;